<template>
  <div class="p-pnt">
    <div class="l-container">
      <!-- <div class="c-box mb-16 mt-px"> -->
        <Header v-model="menuBasicInfo"/>
        <MenuNavigation />
        <router-view></router-view>
      </div>
    <!-- </div> -->
  </div>
</template>

<script>
import _ from 'lodash'
import Header from './Header'
import MenuNavigation from './MenuNavigation'
import { BREADCRUMBS } from '@/store/modules/app/actions'
import { GET_MENU_BASIC_INFO, ADD_VIEWED_LIST } from '@/store/modules/menu/actions'

export default {
  name: 'MenuMainContainer',
  components: {
    Header,
    MenuNavigation
  },
  data() {
    return {
      menuBasicInfo: null
    }
  },
  created() {
    this.getMenuBasicInfo()
  },
  mounted() {
    this.addInListHistory()
  },
  watch: {
  },
  computed: {

  },
  methods: {
    addInListHistory() {
      const { menuNo } = this.$route.params
      const serviceType = 'tour'
      this.$store.dispatch(ADD_VIEWED_LIST, { menuNo, serviceType }).then(
        (data) => {
        }
      )
    },
    getMenuBasicInfo() {
      const { menuNo } = this.$route.params
      this.$store.dispatch(GET_MENU_BASIC_INFO, { menuNo }).then(
        (data) => {
          this.menuBasicInfo = data
          // update breadcrumbs
          const breadcrumbs = _.cloneDeep(_.get(this.$route, 'meta.breadcrumbs', []))
          if(breadcrumbs.length < 3) {
            breadcrumbs.push({
              title: _.get(this.menuBasicInfo, 'menuNm', '')
            })
          }
          this.$store.dispatch(BREADCRUMBS, breadcrumbs)
        },
        () => {
        }
      )
    }
  }
}
</script>